<template>
  <div class="header-actions">
    <template v-if="!$vuetify.display.xs">
      <v-btn
        v-for="action in actions"
        :key="action.key"
        v-track:[trackName(action)].click="trackData(action)"
        color="primary"
        :variant="action.variant"
        @click="action.onClick"
      >
        <v-icon>add</v-icon>
        {{ action.title }}
      </v-btn>
    </template>

    <template v-else-if="actions.length">
      <!-- Tracked here only when it runs its one action straight away. -->
      <v-btn
        v-track:[trackName(actions[0])].click="isSingle ? trackData(actions[0]) : untracked"
        color="primary"
        icon
        rounded="circle"
        :width="40"
        :height="40"
        :aria-label="$t('add')"
        @click="open"
      >
        <v-icon>add</v-icon>
      </v-btn>

      <v-bottom-sheet v-model="isSheetOpen">
        <v-list class="header-actions__sheet">
          <v-list-subheader v-if="sheetTitle">{{ sheetTitle }}</v-list-subheader>
          <v-list-item
            v-for="action in sheetActions"
            :key="action.key"
            v-track:[trackName(action)].click="trackData(action)"
            :prepend-icon="action.sheetIcon"
            :title="action.sheetTitle ?? action.title"
            @click="onSheetItemClick(action)"
          />
        </v-list>
      </v-bottom-sheet>
    </template>
  </div>
</template>

<script>
  // The tracker skips a click whose data has isDisabled, so an action without
  // tracking can still share the element that carries v-track.
  const UNTRACKED = { isDisabled: true };

  // A view's add buttons: side by side on wider screens; on a phone, one +
  // button that runs a single action or offers several in a bottom sheet.
  // Pass only the actions the user is allowed to take.
  export default {
    props: {
      // { key, title, onClick, variant?, sheetTitle?, sheetIcon?, track?: { name, data } }
      // Main action last: it then sits rightmost in the row and first in the
      // sheet.
      actions: {
        type: Array,
        required: true,
      },
      sheetTitle: {
        type: String,
        default: '',
      },
    },
    data() {
      return {
        isSheetOpen: false,
        untracked: UNTRACKED,
      };
    },
    computed: {
      isSingle() {
        return this.actions.length === 1;
      },
      sheetActions() {
        return [...this.actions].reverse();
      },
    },
    methods: {
      // Called by the view too, for other ways into the same choice.
      open() {
        if (this.isSingle) {
          this.actions[0].onClick();
        } else if (this.actions.length) {
          this.isSheetOpen = true;
        }
      },
      onSheetItemClick(action) {
        this.isSheetOpen = false;
        action.onClick();
      },
      trackName(action) {
        return action.track?.name ?? 'headerAction';
      },
      trackData(action) {
        return action.track?.data ?? UNTRACKED;
      },
    },
  };
</script>

<style lang="scss" scoped>
  // The header lays out its actions itself.
  .header-actions {
    display: contents;
  }
</style>
